import { render } from "./AppDismiss.vue?vue&type=template&id=334241a7"
import script from "./AppDismiss.vue?vue&type=script&lang=js"
export * from "./AppDismiss.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__